/* eslint-disable camelcase, no-underscore-dangle */
import {
  ProduitApiResponse,
  ProduitCatalogueCooperativeApiResponse,
  UpdateCooperativeProductResponse,
} from '@b2ag/module-product-sdk'
import * as variantMapper from './variant.mapper'

const mapCommonProductFields = (product: ProduitApiResponse | ProduitCatalogueCooperativeApiResponse) => ({
  id: product._id,
  isRestrictedExplosivesPrecursor: product.is_restricted_explosives_precursor,
  activeSubstances: product.active_substances,
  isMentionBioControl: product.is_mention_bio_control,
  cropProtectionProductFormulationName: product.crop_protection_product_formulation_name,
  images: product.images,
  kind: product.kind,
  marketAuthorization: product.market_authorization,
  name: product.name,
  isMentionOrganic: product.is_mention_organic,
  associatedUses: product.associated_uses,
  supplier: product.supplier,
  categories: product.categories,
  family: product.family,
  description: product.description,
  characteristics: product.characteristics,
  documentation: product.documentation,
})

export const mapFromProduct = (product: ProduitApiResponse) => {
  const { variants = [] } = product
  return {
    ...mapCommonProductFields(product),
    variants: variants.map(variantMapper.mapFromVariant),
    associatedProducts: [],
  }
}

export const mapFromCooperativeCatalogProduct = (product: ProduitCatalogueCooperativeApiResponse) => {
  const { variants = [] } = product
  return {
    ...mapCommonProductFields(product),
    variants: variants.map(variantMapper.mapFromVariantCatalogueCooperative),
    isHighlighted: product.is_highlighted,
    cooperativeReview: product.cooperative_review,
    associatedProducts: product.associated_products || [],
  }
}

export const mapFromUpdateCooperativeProductResponse = (response: UpdateCooperativeProductResponse) => ({
  id: response.id,
  cooperativeId: response.cooperative_id,
  nationalId: response.national_id,
  isHighlighted: response.is_highlighted,
  upsides: response.upsides,
  tips: response.tips,
})
